import React from 'react';
import BrandingFooter from '../common/BrandingFooter';
import MatchWidgetShell from '../common/MatchWidgetShell';
import MatchScoreHero from '../common/MatchScoreHero';
import MatchMetaGrid from '../common/MatchMetaGrid';
import MatchStatsChips from '../common/MatchStatsChips';

export default function MatchInfo({
  showBranding = false,
  competitionLabel = 'Premier League',
  featuredMatch = {},
}) {
  const m = featuredMatch || {};
  const hasMeta = m.venue || m.attendance || m.referee || m.coaches?.home || m.kickoff;

  return (
    <div>
      <MatchWidgetShell competitionLabel={competitionLabel} subtitle="Match information">
        <MatchScoreHero match={m} compact />
        <MatchStatsChips match={m} events={m.events} />
        <MatchMetaGrid match={m} />
        {m.ht?.label && (
          <div className="px-4 pb-4">
            <div className="sw-meta-tile">
              <span className="sw-meta-tile__icon" style={{ color: 'var(--sw-accent)' }}>⏱</span>
              <div>
                <p className="sw-meta-tile__label">Half-time</p>
                <p className="sw-meta-tile__value">{m.ht.label}</p>
              </div>
            </div>
          </div>
        )}
        {!hasMeta && !m.ht?.label && (
          <p className="text-center text-xs py-8 px-4" style={{ color: 'var(--sw-muted)' }}>
            Match details not available yet.
          </p>
        )}
      </MatchWidgetShell>
      {showBranding && <BrandingFooter />}
    </div>
  );
}
